// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 로그인 만료 — 작업 화면을 그대로 둔 채 그 위에 로그인 창 (App 은 내리지 않는다) */
.session-expired-overlay {
  position: fixed;
  inset: 0;
  z-index: 1500;            /* 모든 창(1001) 위, 공통 대화상자(10000) 아래 */
  overflow: auto;
  background: rgba(245, 246, 248, 0.97);
  animation: session-expired-in 180ms ease-out;
}
[data-theme="dark"] .session-expired-overlay { background: rgba(24, 26, 30, 0.97); }

.session-expired-notice {
  position: sticky;
  top: 0;
  z-index: 1;
  display: flex;
  flex-wrap: wrap;
  gap: 4px 10px;
  justify-content: center;
  align-items: baseline;
  padding: 10px 16px;
  font-size: 13px;
  line-height: 1.5;
  text-align: center;
  color: #7a4d00;
  background: #fff4e0;
  border-bottom: 1px solid #f0d8a8;
}
[data-theme="dark"] .session-expired-notice { color: #f0cf8f; background: #3a2f1c; border-bottom-color: #5c4a28; }

@keyframes session-expired-in { from { opacity: 0; } to { opacity: 1; } }

@media (prefers-reduced-motion: reduce) {
  .session-expired-overlay { animation: none; }
}
`, "",{"version":3,"sources":["webpack://./src/components/SessionExpiredGate.css"],"names":[],"mappings":"AAAA,uDAAuD;AACvD;EACE,eAAe;EACf,QAAQ;EACR,aAAa,aAAa,oCAAoC;EAC9D,cAAc;EACd,qCAAqC;EACrC,4CAA4C;AAC9C;AACA,+CAA+C,kCAAkC,EAAE;;AAEnF;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,aAAa;EACb,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,gCAAgC;AAClC;AACA,8CAA8C,cAAc,EAAE,mBAAmB,EAAE,4BAA4B,EAAE;;AAEjH,gCAAgC,OAAO,UAAU,EAAE,EAAE,KAAK,UAAU,EAAE,EAAE;;AAExE;EACE,2BAA2B,eAAe,EAAE;AAC9C","sourcesContent":["/* 로그인 만료 — 작업 화면을 그대로 둔 채 그 위에 로그인 창 (App 은 내리지 않는다) */\n.session-expired-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1500;            /* 모든 창(1001) 위, 공통 대화상자(10000) 아래 */\n  overflow: auto;\n  background: rgba(245, 246, 248, 0.97);\n  animation: session-expired-in 180ms ease-out;\n}\n[data-theme=\"dark\"] .session-expired-overlay { background: rgba(24, 26, 30, 0.97); }\n\n.session-expired-notice {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px 10px;\n  justify-content: center;\n  align-items: baseline;\n  padding: 10px 16px;\n  font-size: 13px;\n  line-height: 1.5;\n  text-align: center;\n  color: #7a4d00;\n  background: #fff4e0;\n  border-bottom: 1px solid #f0d8a8;\n}\n[data-theme=\"dark\"] .session-expired-notice { color: #f0cf8f; background: #3a2f1c; border-bottom-color: #5c4a28; }\n\n@keyframes session-expired-in { from { opacity: 0; } to { opacity: 1; } }\n\n@media (prefers-reduced-motion: reduce) {\n  .session-expired-overlay { animation: none; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
